// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3ujRJ","label":"Completed_label__2gjN3"};